export default "__VITE_ASSET__CO8x9yPa__"